'use strict';

function trans(key) {
  return key;
}
function TODO_trans(key) {
  return key;
}
function notrans(str) {
  return str;
}

exports.TODO_trans = TODO_trans;
exports.notrans = notrans;
exports.trans = trans;
//# sourceMappingURL=trans.cjs.map
